import BranchDeepLinksScript from '@Analytics/BranchDeepLinksScript';
import QuizLayout from '@cont/DST/Layout';
import setupInitialProps from '@utils/setupInitialProps';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { useRouter } from 'next/router';
import useSetMetaInfo from '@cont/DST/useSetMetaInfo';
import { handleDSTRedirectAndFetch } from '@cont/DST/utils';
import { emptyObject } from '@constants/empty';
import { getIsSubscribedToGoal } from '@selectors/subscription';
import { getDSTEndpoint } from '@cont/SeeAll/TestSeriesListing/DailyScholarshipTest/apiHelper';
import isEmptyObject from '@utils/isEmptyObject';
import { redirectToRoute } from '@utils/route';
import { getDefaultHost } from '@utils/api-helper/host';
import { simpleFetch as fetcher } from '@api/fetchers';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const DefaultHost = getDefaultHost();

const QuizInfo = ({ quizInfo, classPreference, attemptsInfo }) => {
  const { query } = useRouter();
  const { goalUID, goalSlug } = query;

  useSetMetaInfo({ quizInfo, classPreference, attemptsInfo });

  const name = 'Scholarship Test | Unacademy';
  const description = 'Daily Scholarship Test';
  const openGraph = {
    title: name,
    description,
    url: `https://unacademy.com/goal/${goalSlug}/${goalUID}/scholarship-test`
  };

  return (
    <>
      <NextSeo title={name} description={description} openGraph={openGraph} />
      <Head>
        <title>{name}</title>
      </Head>
      <BranchDeepLinksScript />
    </>
  );
};

QuizInfo.pageInfo = {
  name: 'Daily Scholarship Test',
  isMWebSupported: true,
  layoutOptions: {
    hideIntercom: true,
    hideFreshbot: true,
    disableDarkMode: true
  }
};

QuizInfo.getInitialProps = setupInitialProps(
  async ({ store, query, isServer, res }) => {
    const { goalUID, goalSlug } = query;
    const { auth } = store.getState();
    const { isLoggedIn, me, accessToken } = auth || emptyObject;

    const dstInfo = await fetcher(`${DefaultHost}${getDSTEndpoint(goalUID)}`);

    if (isEmptyObject(dstInfo)) {
      return redirectToRoute(isServer, res, '/');
    }

    if (isLoggedIn) {
      const isPlusUser = getIsSubscribedToGoal(goalUID)(store.getState());
      const { quizInfo, classPreference, attemptsInfo } =
        await handleDSTRedirectAndFetch({
          isPlusUser,
          goalUID,
          goalSlug,
          accessToken,
          searchToken: me.searchJwtToken,
          isServer,
          res
        });

      return {
        quizInfo,
        classPreference,
        attemptsInfo
      };
    }
  },
  QuizInfo.pageInfo
);

QuizInfo.Layout = QuizLayout;

export default QuizInfo;
QuizInfo.Wrapper = PageReduxProvider;
